import { useEffect, useState } from 'react';
import SearchSelect from "../ui-components/SearchSelect";
import Button from "../ui-components/Button";
import { useIntl } from 'react-intl';

const DEFAULT_OUTPUT_OBJ = {
  kcolor_question: null,
  surface_question: null,
};

const ServiceConfiguratorBlockCalculationKColorGenerator = ({
  kColorValue,
  updateKColor,
  setSelectedOperator,
  questions,
}) => {
  // hooks
  const intl = useIntl();

  const kcolorObject = kColorValue === "kcolor" ? { ...DEFAULT_OUTPUT_OBJ, original: kColorValue } : JSON.parse(kColorValue);
  const [selectedKColorQuestion, setSelectedKColorQuestion] = useState(
    kColorValue === "kcolor"
      ? null
      : {
          label:
            questions.filter((q) => q.id === kcolorObject.kcolor_question)[0]
              ?.name || `Question ${kcolorObject.kcolor_question}`,
          value: kcolorObject.kcolor_question,
        }
  );

    // const [selectedSurfaceQuestion, setSelectedSurfaceQuestion] = useState(
    //   kColorValue === "kcolor"
    //     ? null
    //     : {
    //         label:
    //           questions.find((q) => q.id === kcolorObject.surface_question)
    //             ?.name || `Question ${kcolorObject.surface_question}`,
    //         value: kcolorObject.surface_question,
    //       }
    // );

  useEffect(() => {
    updateKColor(kcolorObject);
  }, []);

  return (
    <div className="flex flex-col w-full mb-8 mt-8">
      <div className=" mb-2 flex text-center justify-center">
        <p className="font-bold">{intl.formatMessage({id:"kcolor", defaultMessage:"K Color"})}</p>
      </div>
      <SearchSelect
        label={intl.formatMessage({id:"select_kcolor_question", defaultMessage:"Select K Color question"})}
        options={questions
          .filter((q) => q.input_type === "k_color_input")
          .map((q) => ({
            label: q.name || `Question ${q.id}`,
            value: q.id,
          }))}
        value={selectedKColorQuestion}
        onChange={(e) => {
          setSelectedKColorQuestion(e);
          updateKColor({
            ...kcolorObject,
            kcolor_question: e.value,
          });
        }}
      />
      {/*<SearchSelect*/}
      {/*  label={intl.formatMessage({id:"select_surface_question", defaultMessage:"Select surface question"})}*/}
      {/*  options={questions*/}
      {/*    .filter((q) => q.input_type === "number_input")*/}
      {/*    .map((q) => ({*/}
      {/*      label: q.name || `Question ${q.id}`,*/}
      {/*      value: q.id,*/}
      {/*    }))}*/}
      {/*  value={selectedSurfaceQuestion}*/}
      {/*  onChange={(e) => {*/}
      {/*    setSelectedSurfaceQuestion(e);*/}
      {/*    updateKColor({*/}
      {/*      ...kcolorObject,*/}
      {/*      surface_question: e.value,*/}
      {/*    });*/}
      {/*  }}*/}
      {/*/>*/}

      <div className="mt-4 flex justify-end">
        <Button onClick={() => setSelectedOperator(null)}>DONE</Button>
      </div>
    </div>
  );
}

export default ServiceConfiguratorBlockCalculationKColorGenerator;